import { z } from 'zod';
import { apiClient } from '@/core/api/client';
import { ENDPOINTS } from '@/core/api/endpoints';
import { TarifaFullSchema, } from '@/data/dto/tarifa';
function limpiar(values) {
    return {
        nombre: values.nombre,
        tipoClase: values.tipoClase,
        disciplina: values.disciplina || null,
        cantPersonasMin: values.cantPersonasMin,
        cantPersonasMax: values.cantPersonasMax,
        duracionHoras: values.duracionHoras,
        modoPrecio: values.modoPrecio,
        precio: values.precio,
        incluyeEquipo: values.incluyeEquipo,
        vigenteDesde: values.vigenteDesde,
        vigenteHasta: values.vigenteHasta || null,
        visibleWeb: values.visibleWeb,
        color: values.color || null,
    };
}
export const tarifasAdminApi = {
    async listar(sucursalId, opts) {
        const params = {};
        if (opts?.activo !== undefined)
            params.activo = String(opts.activo);
        const res = await apiClient.get(`${ENDPOINTS.sucursales}/${sucursalId}/tarifas`, { params });
        const data = res.data;
        if (Array.isArray(data))
            return z.array(TarifaFullSchema).parse(data);
        return z.object({ items: z.array(TarifaFullSchema) }).parse(data).items;
    },
    async ver(id) {
        const res = await apiClient.get(`${ENDPOINTS.tarifas}/${id}`);
        return TarifaFullSchema.parse(res.data);
    },
    async crear(sucursalId, values) {
        const res = await apiClient.post(`${ENDPOINTS.sucursales}/${sucursalId}/tarifas`, limpiar(values));
        return TarifaFullSchema.parse(res.data);
    },
    async editar(id, values) {
        const res = await apiClient.patch(`${ENDPOINTS.tarifas}/${id}`, limpiar(values));
        return TarifaFullSchema.parse(res.data);
    },
    async cerrar(id, hasta) {
        const res = await apiClient.post(`${ENDPOINTS.tarifas}/${id}/cerrar`, { hasta });
        return TarifaFullSchema.parse(res.data);
    },
    async desactivar(id) {
        await apiClient.delete(`${ENDPOINTS.tarifas}/${id}`);
    },
};
